import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useFreshRef } from 'src/lib/hooks';

import { FormProduct } from '../../components/FormProduct';
import { useDataContextValue } from '../../context';

import { useStyles } from './useStyles';

const DEFAULT_VALUE = {};

export const ContentProduct = ({
  className,
  classes,
  value,
  onChange,
  onFieldFocus,
  onFieldBlur,
  errors,
  disabled,
  isEmailPromotion,
}) => {
  const styles = useStyles({ classes });
  const { generationTool, limitMultilineMaxRows } = useDataContextValue();

  const valueRef = useFreshRef(value);

  const handleFieldChange = useCallback(
    (field, fieldValue) => {
      const newValue = {
        ...valueRef.current,
        [field]: fieldValue,
      };
      onChange(newValue, field);
    },
    [onChange, valueRef]
  );

  return (
    <div className={cx(styles.root, className)}>
      <FormProduct
        generationTool={generationTool}
        content={value || DEFAULT_VALUE}
        onFieldChange={handleFieldChange}
        onFieldFocus={onFieldFocus}
        onFieldBlur={onFieldBlur}
        errors={errors}
        disabled={disabled}
        isEmailPromotion={isEmailPromotion}
        limitMultilineMaxRows={limitMultilineMaxRows}
      />
    </div>
  );
};

ContentProduct.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  value: PropTypes.shape(),
  onChange: PropTypes.func.isRequired,
  onFieldFocus: PropTypes.func,
  onFieldBlur: PropTypes.func,
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
  isEmailPromotion: PropTypes.bool,
};

ContentProduct.defaultProps = {
  className: null,
  classes: null,
  value: {},
  onFieldFocus: null,
  onFieldBlur: null,
  errors: null,
  disabled: false,
  isEmailPromotion: false,
};
